(function () {
  'use strict';
  if (window.__uydBratsLoader) { window.__uydBratsLoader.scan(); return; }

  var records = new WeakMap();
  var assets = new Map();
  function assetUrl(base, filename) {
    if (!base) throw new Error('Set the public Live bundle base URL in the theme editor.');
    var url = new URL(base);
    var local = ['localhost', '127.0.0.1', '[::1]'].indexOf(url.hostname) !== -1;
    if ((url.protocol !== 'https:' && !(local && url.protocol === 'http:')) || url.username || url.password || url.search || url.hash) throw new Error('The Live bundle URL must use HTTPS.');
    return url.href.replace(/\/+$/, '') + '/' + filename;
  }
  function load(url, type) {
    if (assets.has(url)) return assets.get(url);
    var promise = new Promise(function (resolve, reject) {
      var element = document.createElement(type === 'css' ? 'link' : 'script');
      if (type === 'css') { element.rel = 'stylesheet'; element.href = url; }
      else { element.src = url; element.async = true; }
      element.onload = function () { resolve(); };
      element.onerror = function () { element.remove(); assets.delete(url); reject(new Error('Live could not load. Check the bundle URL and try again.')); };
      document.head.appendChild(element);
    });
    assets.set(url, promise);
    return promise;
  }
  function showError(section, message) {
    var status = section.querySelector('[data-uyd-live-load-status]');
    if (!status) return;
    status.hidden = false;
    status.textContent = message;
    var retry = document.createElement('button');
    retry.type = 'button'; retry.textContent = 'Try again';
    retry.onclick = function () { mount(section); };
    status.appendChild(retry);
  }
  // The Brats address bar stays above the page while scrolling. Keep the
  // compact live player below it, including after fonts or viewport resize.
  function followHeader(section) {
    var header = document.querySelector('.y2k-chrome-header__sticky');
    if (!header) return function () {};
    var property = '--uyd-live-sticky-top';
    var previous = section.style.getPropertyValue(property);
    var priority = section.style.getPropertyPriority(property);
    function update() {
      var style = getComputedStyle(header);
      var height = header.getBoundingClientRect().height;
      var pinned = style.position === 'sticky' || style.position === 'fixed';
      var offset = pinned && height > 0 ? height + Math.max(0, parseFloat(style.top) || 0) : 0;
      section.style.setProperty(property, Math.ceil(offset + 8) + 'px');
    }
    update();
    var observer = typeof ResizeObserver === 'function' ? new ResizeObserver(update) : null;
    if (observer) observer.observe(header);
    window.addEventListener('resize', update);
    return function () {
      if (observer) observer.disconnect();
      window.removeEventListener('resize', update);
      if (previous) section.style.setProperty(property, previous, priority);
      else section.style.removeProperty(property);
    };
  }
  function mount(section) {
    var target = section.querySelector('[data-uyd-live-mount]');
    var status = section.querySelector('[data-uyd-live-load-status]');
    if (!target || !status) return;
    var old = records.get(section);
    if (old && (old.loading || old.handle)) return;
    var record = { loading: true, handle: null, canceled: false, releaseHeader: null };
    records.set(section, record);
    status.hidden = false; status.textContent = 'Opening Brats Live…';
    var js, css;
    try { js = assetUrl(section.dataset.bundleBase, 'uyd-live.js'); css = assetUrl(section.dataset.bundleBase, 'uyd-live.css'); }
    catch (error) { record.loading = false; showError(section, error.message); return; }
    Promise.all([load(css, 'css'), load(js, 'js')]).then(function () {
      if (record.canceled || records.get(section) !== record) return;
      if (!window.UYDLive || typeof window.UYDLive.mount !== 'function') throw new Error('Live loaded without its widget. Try again.');
      record.handle = window.UYDLive.mount(target, {
        apiOrigin: section.dataset.apiOrigin,
        sellerSlug: section.dataset.sellerSlug,
        showSlug: section.dataset.showSlug
      });
      record.releaseHeader = followHeader(section);
      record.loading = false; status.hidden = true;
    }).catch(function (error) {
      if (record.canceled || records.get(section) !== record) return;
      record.loading = false;
      if (!window.UYDLive || typeof window.UYDLive.mount !== 'function') {
        assets.delete(js);
        document.querySelectorAll('script[src]').forEach(function (script) { if (script.src === js) script.remove(); });
      }
      showError(section, error.message || 'Live could not load. Try again.');
    });
  }
  function unload(section) {
    var record = records.get(section);
    if (!record) return;
    record.canceled = true;
    if (record.releaseHeader) record.releaseHeader();
    record.handle && record.handle.destroy(); records.delete(section);
  }
  function scan(root) {
    if (root && root.matches && root.matches('[data-uyd-live-section]')) mount(root);
    (root || document).querySelectorAll('[data-uyd-live-section]').forEach(mount);
  }
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    if (event.target.matches && event.target.matches('[data-uyd-live-section]')) unload(event.target);
    event.target.querySelectorAll('[data-uyd-live-section]').forEach(unload);
  });
  window.__uydBratsLoader = { scan: scan, unload: unload };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); }, { once: true });
  else scan();
})();
